<template>
  <div class="container">
    <div class="first-container">
      <div class="first-class">
        <div
          class="class-item"
          :class="{ active: index === currentCategory }"
          :key="index"
          @click="onChooseCategory(index)"
          v-for="(item, index) in categories"
        >
          {{ item.categoryName }}
        </div>
      </div>
    </div>
    <div class="second-container">
      <!-- banner 模块-->
      <div class="banner" v-if="ads.length > 0">
        <swiper
          class="ads-banner"
          :options="{
            autoplay: true,
            loop: true,
          }"
        >
          <swiper-slide class="ads-banner-slide" :key="index" v-for="(item, index) in ads">
            <router-link
              class="ads-banner-item"
              :to="item.url"
              :style="{ backgroundImage: `url(${item.img})` }"
            ></router-link>
          </swiper-slide>
        </swiper>
      </div>
      <template v-if="categories.length > 0">
        <div :key="index" v-for="(item, index) in categories[currentCategory].sons">
          <router-link
            class="second-title"
            :to="{ name: 'productList', query: { categoryName: item.categoryName, categoryId: item.categoryId } }"
          >
            <span>{{ item.categoryName }}</span>
          </router-link>
          <div class="production-container">
            <router-link
              class="production-item"
              :key="index"
              :to="{ name: 'productList', query: { categoryName: item.categoryName, categoryId: item.categoryId } }"
              v-for="(item, index) in item.sons"
            >
              <product-cover size="small" :name="item.categoryName" :cover="item.categoryCover"></product-cover>
            </router-link>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<style lang="sass" scoped src="./Category.sass"></style>

<script>
import ProductCover from '@/components/product-cover';
import product from '@/api/product';

export default {
  data: () => ({
    windowHeight: 0,

    categories: [],

    currentCategory: 0,

    currentSons: null,

    ads: [],
  }),

  mounted() {
    this.fetchCategories();
    this.fetchAds();
  },

  components: {
    ProductCover,
  },

  methods: {
    /**
     * 选择左侧栏分类
     */
    onChooseCategory(index) {
      this.currentCategory = index;
    },

    /**
     * 获取商品分类列表
     */
    fetchCategories() {
      product.fetchCategories({}).then(res => {
        const {
          data: { code, data },
        } = res;

        if (code > 0) {
          return;
        }

        this.categories = data;
      });
    },

    /**
     * 获取广告
     */
    fetchAds() {
      const payload = {
        type: 'category',
      };

      product.fetchAds(payload).then(res => {
        const {
          data: { code, data },
        } = res;

        if (code > 0) {
          return;
        }

        this.ads = data.map(item => {
          return {
            ...item,
            url:
              item.linkType === 'category'
                ? { name: 'productList', query: { categoryId: item.linkId } }
                : { name: 'productDetail', params: { id: item.linkId } },
          };
        });
      });
    },
  },
};
</script>
